import { ref, onMounted, onBeforeUnmount, computed } from 'vue-demi';
import FEGORender from '@futuweb/fego-render';
import { TIME_LIMIT, DISPLAY_TYPE } from '../../constants';
import 'intersection-observer';
import Cache from '../../fego/Cache';
const { useEnv } = require('@fegobull/webapi').use;
const { isPreRender } = useEnv();

const { store: { variable }, library } = FEGORender;
const { dayjs } = library;

export default function useCmpInScreenHide({ enableCloseBtn, closeTimeLimit, cmpInScreenHide }) {
    const displayBox = ref(DISPLAY_TYPE.HIDDEN);
    const urlSuffix = variable.data.URL_SUFFIX;
    const cache = new Cache({
        prefix: `fixed-box-${urlSuffix}`
    });
    // 关闭标识
    const closeSign = computed(() => {
        return `close_${closeTimeLimit}`;
    });
    let observer = null;
    const observeElementVisible = {};

    /**
     * 初始化显示状态
     */
    const initDisplayStatus = () => {
        let flag = DISPLAY_TYPE.HIDDEN;
        if (enableCloseBtn) {
            flag = DISPLAY_TYPE.CLOSE;
            const cacheStatus = cache.getCacheStatus(closeSign.value);
            switch (closeTimeLimit) {
                case TIME_LIMIT.DAY:
                    const expTime = dayjs(cacheStatus * 1e3 + 24 * 60 * 60 * 1000).unix();
                    const now = dayjs().unix();
                    if (expTime < now) {
                        // 默认隐藏，防止闪动，由滚动监听器判断
                        flag = DISPLAY_TYPE.HIDDEN;
                    }
                    break;
                case TIME_LIMIT.FOREVER:
                    flag = cacheStatus ? DISPLAY_TYPE.CLOSE : DISPLAY_TYPE.HIDDEN;
                    break;
                default:
                    // 默认隐藏，防止闪动，由滚动监听器判断
                    flag = DISPLAY_TYPE.HIDDEN;
                    break;
            }
        }
        displayBox.value = flag;
    };

    /**
     * 关闭容器
     */
    const close = () => {
        // 缓存关闭状态
        switch (closeTimeLimit) {
            case TIME_LIMIT.DAY:
                cache.setCacheStatus(closeSign.value, dayjs().unix());
                break;
            case TIME_LIMIT.FOREVER:
                cache.setCacheStatus(closeSign.value, '1');
                break;
            default:
                break;
        }
        displayBox.value = DISPLAY_TYPE.CLOSE;
        observer?.disconnect?.();
    };

    const startObserver = () => {
        // 如果初始化被关闭，则不处理
        if (displayBox.value === DISPLAY_TYPE.CLOSE) {
            return;
        }
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };
        const callback = (entries, o) => {
            entries.forEach((entry) => {
                // const isVisible = entry.isIntersecting;
                // console.log(`Element is ${isVisible ? 'visible' : 'not visible'}`, entry.target);
                // fego 组件有 data-id 标记，可从 dataset 上获取
                observeElementVisible[entry.target.dataset.id] = entry.isIntersecting;
            });
            displayBox.value = !Object.values(observeElementVisible)
                .some((isVisible) => isVisible) ? DISPLAY_TYPE.DISPLAY : DISPLAY_TYPE.HIDDEN;
        };
        observer = new IntersectionObserver(callback, options);
        setTimeout(() => {
            cmpInScreenHide.forEach((cmpId) => {
                try {
                    const vm = FEGORender.store.cmp.getVmById(cmpId);
                    if (vm && vm.$el) {
                        observer.observe(vm.$el);
                    }
                } catch (error) {
                    // 处理组件被删除无法 get 到的情况
                    console.error('observe cmp error', cmpId, error);
                    displayBox.value = DISPLAY_TYPE.DISPLAY;
                    return;
                }
            });
        }, 300);
    };

    onMounted(() => {
        if (isPreRender) {
            return;
        }
        initDisplayStatus();
        startObserver();
    });

    onBeforeUnmount(() => {
        observer?.disconnect?.();
    });


    return {
        displayBox,
        close
    };
}
